module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Because the BRI understands your reading needs, we’ve divided the contents by length as well as subject.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("Short")]), _vm._v("—a quick read")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("Medium")]), _vm._v("—2 to 3 pages")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("Long")]), _vm._v("—for those extended visits, when something a little more involved is required")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("* Extended")]), _vm._v("—for those leg-numbing experiences")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span')])]), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch32aa"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span')]), _c('span', {
    attrs: {
      "href": "#/Chapter032#ch32aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BATHROOM LORE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch32a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter032#ch32a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch32"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter032#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncle John’s Stall of Fame")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch109"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter109#ch109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Toilets Explode")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch173"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter173#ch173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toilet Paper Capers")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch188"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter188#ch188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bathroom Jokes for 10-Year-Olds")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch245"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter245#ch245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Toilets Explode")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch59a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter059#ch59a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch59"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter059#ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stall of Fame: The "), _c('i', [_vm._v("U")]), _vm._v("-1206")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch74"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter074#ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bathroom News: Airplane Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch131"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter131#ch131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toilet Paper in the News")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch199"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter199#ch199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncle John’s Stall of Fame")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch235"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter235#ch235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stall of Fame: Mr. Floatie")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch253"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter253#ch253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“This Place is a Toilet”")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch2aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter002#ch2aa"
    }
  }, [_c('b', [_vm._v("SILVER ANNIVERSARY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch2a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter002#ch2a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter002#ch2"
    }
  }, [_vm._v("The BRI Anthem")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch79"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter079#ch79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Magic Number")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch147"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter147#ch147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Linings")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch247"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter247#ch247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A History of Y")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch264a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter264#ch264a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch264"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter264#ch264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*At 25")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch63aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter063#ch63aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ORIGINS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch63a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter063#ch63a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch63"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter063#ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dope on Rope")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch83"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter083#ch83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage Firsts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch117"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter117#ch117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All About Corduroy")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch150"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter150#ch150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ahead of Their Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch168"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter168#ch168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Military Firsts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch187a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter187#ch187a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch187"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter187#ch187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Random Firsts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch12aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter012#ch12aa"
    }
  }, [_c('b', [_vm._v("LIFE IS STRANGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch12a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter012#ch12a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter012#ch12"
    }
  }, [_vm._v("Treasure in the Attic")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch23"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter023#ch23"
    }
  }, [_vm._v("It Could Only Happen In")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch76"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter076#ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Thy Neighbor")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch123"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter123#ch123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Imitates Art")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch140"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter140#ch140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s a Weird, Weird World")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch154"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter154#ch154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s What’s Inside That Counts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch181"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter181#ch181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ironic, Isn’t It?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch208"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter208#ch208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Plane Weird")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch219"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter219#ch219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Plane Weird: “Open Mic” Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch66a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter066#ch66a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch66"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter066#ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Date? "), _c('i', [_vm._v("Last")]), _vm._v(" Date!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch152"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter152#ch152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncle John’s Creative Teaching Awards")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch205a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter205#ch205a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch205"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter205#ch205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strange Fate of Eben Byers")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch78aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter078#ch78aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("LAW & ORDER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch78a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter078#ch78a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch78"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter078#ch78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Police Blotter: Cheeseburger Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch106"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter106#ch106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poetic Justice")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch144"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter144#ch144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loony Laws")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch165"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter165#ch165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Police Blotter")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch178"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter178#ch178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“It Was Like Saddling a Porpoise”")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch9a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter009#ch9a"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter009#ch9"
    }
  }, [_vm._v("Behind Bars: Most Time Served")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch111"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter111#ch111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Made Jack “The Ripper”?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch200"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter200#ch200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Busted on Facebook")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch246"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter246#ch246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not-Murder Mysteries")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch249"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter249#ch249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Serial Killers: Unsolved Cases")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch242a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter242#ch242a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch242"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter242#ch242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*The Innocence Project")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch37aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter037#ch37aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("FORGOTTEN HISTORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch234a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter234#ch234a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch234"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter234#ch234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Meteoric Footnote")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch37a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter037#ch37a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch37"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter037#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief History of the Negro League")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch56"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter056#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edifice Wrecks")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch92"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter092#ch92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dustbin of History: Barbara Hutton")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch250"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter250#ch250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scroggied")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch160a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter160#ch160a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch160"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter160#ch160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Real Scrooge")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch189"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter189#ch189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("America’s Forgotten Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch248"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter248#ch248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burned at the Skate")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch10aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter010#ch10aa"
    }
  }, [_c('b', [_vm._v("MOUTHING OFF")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch10a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter010#ch10a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter010#ch10"
    }
  }, [_vm._v("Mr. Black & Ms. White")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter017#ch17"
    }
  }, [_vm._v("Mr. Baseball")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch25"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter025#ch25"
    }
  }, [_vm._v("Nora’s Notions")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch39"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter039#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parenthood")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch73"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter073#ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Liners")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch100"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter100#ch100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laugh Lines")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch133"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter133#ch133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Worry")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch177"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter177#ch177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Are You?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch210"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter210#ch210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words To Live By")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch237"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter237#ch237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oldsters")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch4aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter004#ch4aa"
    }
  }, [_c('b', [_vm._v("PUBLIC LIVES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch4a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter004#ch4a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter004#ch4"
    }
  }, [_vm._v("The Talented Miss America")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch29"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter029#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Living…")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch86"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter086#ch86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nudes And Prudes")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch113"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter113#ch113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Tweets")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch136"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter136#ch136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Khan the Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch155"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter155#ch155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Any Relation?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch184"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter184#ch184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nudes And Prudes")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch207"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter207#ch207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prince Is 2 Weird")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch258"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter258#ch258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Gold Medal to Silver Screen")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch252a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter252#ch252a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch252"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter252#ch252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("President Conan O’Brien")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch228a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter228#ch228a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch228"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter228#ch228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Feud: The Guccis")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch43aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter043#ch43aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SONG & DANCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch43a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter043#ch43a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch43"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter043#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grunge Code")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch62"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter062#ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Music On TV")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch85"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter085#ch85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pete Best Awards")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch163"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter163#ch163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pop Music: 1987")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch193"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter193#ch193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Tuba!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch31a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter031#ch31a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch31"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter031#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Behind the Hits: Soundtrack Cuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch142"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter142#ch142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Music On TV")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch229"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter229#ch229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Music On TV")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch262"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter262#ch262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Singing Athletes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch15aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter015#ch15aa"
    }
  }, [_c('b', [_vm._v("STAGE & SCREEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch15a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter015#ch15a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter015#ch15"
    }
  }, [_vm._v("Reel Time Bombs")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch42"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter042#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Alien,")]), _vm._v(" Starring Meryl Streep")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch69"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter069#ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sci-Fi Video Treasures")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch122"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter122#ch122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muppet Facts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch129"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter129#ch129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Musical Flops")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch157"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter157#ch157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Me: The Movie")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch172"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter172#ch172",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Simpsons")]), _vm._v(" Movies")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch176"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter176#ch176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take One!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch213"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter213#ch213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sound Of Movies")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch14aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter014#ch14aa"
    }
  }, [_c('b', [_vm._v("THE NEWS ROOM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch14a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter014#ch14a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter014#ch14"
    }
  }, [_vm._v("Flubbed Headlines")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch44"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter044#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poli-Talk")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch65"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter065#ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Muckrakers, Part I")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch166"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter166#ch166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Muckrackers, Part II")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch169"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter169#ch169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Political Briefs")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch196"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter196#ch196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flubbed Headlines")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch68a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter068#ch68a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch68"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter068#ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wikiality Check")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch231"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter231#ch231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Politically Correct Quiz")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch8aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter008#ch8aa"
    }
  }, [_c('b', [_vm._v("THE PRINTED WORD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch8a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter008#ch8a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter008#ch8"
    }
  }, [_vm._v("Comrade Superman")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch134"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter134#ch134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Death is Coming, Warns Weatherman”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch148"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter148#ch148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Your Reading Pleasure")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch257"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter257#ch257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Vs. Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch33a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter033#ch33a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch33"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter033#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Funny Papers")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch118"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter118#ch118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dark and Stormy Write")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch38aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter038#ch38aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("UNDERWEAR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch38a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter038#ch38a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch38"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter038#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pop Pants")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch97"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter097#ch97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underwear in the News")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch139"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter139#ch139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Briefs")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch149"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter149#ch149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underwear in the Air")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch167"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter167#ch167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Tech Underwear")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch215a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter215#ch215a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch215"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter215#ch215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Briefs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch52aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter052#ch52aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("OUTERWEAR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch52a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter052#ch52a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch52"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter052#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Price Beauty?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch161"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter161#ch161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shoe Fads")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch226"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter226#ch226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lighten Up!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch146a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter146#ch146a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch146"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter146#ch146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plain Clothes Men")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch225"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter225#ch225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dumb Blondes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch26aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter026#ch26aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("WATCH YOUR LANGUAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch26a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter026#ch26a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch26"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter026#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dying Languages")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch67"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter067#ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joke Origins")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch103"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter103#ch103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curious Case of the American Accent, Part I")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch127"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter127#ch127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homonym Quiz")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch190"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter190#ch190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quick Brown Fox…")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch217a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter217#ch217a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch217"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter217#ch217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curious Case of the American Accent, Part II")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch259"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter259#ch259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s Another Word for “Thesaurus”?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch11aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter011#ch11aa"
    }
  }, [_c('b', [_vm._v("WORD & PHRASE ORIGINS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch11a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter011#ch11a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter011#ch11"
    }
  }, [_vm._v("Word Origins")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch71"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter071#ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Can Find Them in the Dictionary")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch91"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter091#ch91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Portmanteau Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch159"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter159#ch159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hey, Jay! Pay Fay Wray. Today, Okay?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch211"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter211#ch211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Totally 21st Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch222"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter222#ch222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Portmanteaus")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch6aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter006#ch6aa"
    }
  }, [_c('b', [_vm._v("WORDPLAY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch6a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter006#ch6a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter006#ch6"
    }
  }, [_vm._v("Let "), _c('i', [_vm._v("Me")]), _vm._v(" Write Sign—I Good Speak English")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch48"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter048#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Laugh: Epitaphs")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch88"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter088#ch88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Groaners")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch96"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter096#ch96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s Like A Simile")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch125"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter125#ch125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loaded Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch158"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter158#ch158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Smartphone Autocorrect Quiz")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch185"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter185#ch185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warning Labels")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch239"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter239#ch239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Latin Lexicon")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch60aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter060#ch60aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("YOU’RE MY HERO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch60a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter060#ch60a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch60"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter060#ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Local Heroes")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch151"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter151#ch151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Survival Stories")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch203a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter203#ch203a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch203"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter203#ch203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Real-Life Superheroes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch77a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter077#ch77a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch77"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter077#ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Real-Life Superheroes")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch170"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter170#ch170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The President’s Medal")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch5aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter005#ch5aa"
    }
  }, [_c('b', [_vm._v("A BLUNDERFUL LIFE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch5a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter005#ch5a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter005#ch5"
    }
  }, [_vm._v("Oops!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch40"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter040#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terrible Typos")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch55"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter055#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dumb Crooks")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch130"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter130#ch130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“No Regerts”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch132"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter132#ch132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dumb Crooks: Blabber Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch179"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter179#ch179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oops!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch192"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter192#ch192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dumb Crooks")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch227"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter227#ch227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dumb Crooks: Stoner Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch251"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter251#ch251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weird News")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch101a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter101#ch101a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch101"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter101#ch101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bad Case of the Flue")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch36aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter036#ch36aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("AMERICANA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch36a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter036#ch36a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch36"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter036#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil War Bloodlines")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch82"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter082#ch82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City Nicknames")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch94"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter094#ch94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("America Is…")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch204"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter204#ch204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Name That President")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch120a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter120#ch120a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch120"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter120#ch120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Too Cheap for Graceland")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch202"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter202#ch202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After the Civil War")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch221"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter221#ch221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gold Rush Girls")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch27aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter027#ch27aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CREATURE FEATURES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch27a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter027#ch27a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch27"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter027#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moo")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch35"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter035#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living Lightbulbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch70"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter070#ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Fishy Business")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch95"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter095#ch95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fire Ant Dance")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch115"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter115#ch115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch156"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter156#ch156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird Brains")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch255a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter255#ch255a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch255"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter255#ch255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*Big Noise, Little Bug")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch263"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter263#ch263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*Private Wojtek, the Soldier Bear")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch3aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter003#ch3aa"
    }
  }, [_c('b', [_vm._v("BUSINE$$")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch3a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter003#ch3a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter003#ch3"
    }
  }, [_vm._v("Advertising Firsts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter016#ch16"
    }
  }, [_vm._v("My Dog Has Ph.D.s")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch84"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter084#ch84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Towns for Sale")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch119"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter119#ch119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Money Is No Object!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch22a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter022#ch22a"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch22"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter022#ch22"
    }
  }, [_vm._v("Green Giants")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch49"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter049#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flying Flop: The Lifetime AAirpass")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch99"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter099#ch99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Worst Business Decision Ever?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch126"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter126#ch126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chain-Store Origins")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch195"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter195#ch195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Worst Business Decision Ever? Part II")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch212"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter212#ch212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("World’s Greatest Markets and Bazaars")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch220"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter220#ch220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Towns for Sale")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch233"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter233#ch233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Believe Everything You Hear")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch241"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter241#ch241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Worst Business Decision Ever? Part III")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch30aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter030#ch30aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("FULLY LOADED")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch30a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter030#ch30a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch30"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter030#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“No, "), _c('i', [_vm._v("You")]), _vm._v(" Stick ‘Em Up!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch114"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter114#ch114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s A Gun And a…")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch223a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter223#ch223a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch223"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter223#ch223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Odd Guns")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch7aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter007#ch7aa"
    }
  }, [_c('b', [_vm._v("DOWN THE HATCH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch7a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter007#ch7a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter007#ch7"
    }
  }, [_vm._v("Candy Holidays")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter019#ch19"
    }
  }, [_vm._v("Odd Vodkas")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch53"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter053#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I’ll Have a Fatso Burger”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch61"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter061#ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I’ll Have the Husband and Wife Lung Slice”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch90"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter090#ch90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snap, Crackle…Flop")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch128"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter128#ch128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Put A Cork in It!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch201"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter201#ch201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother Sauces")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch107a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter107#ch107a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch107"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter107#ch107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Firsts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch18aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter018#ch18aa"
    }
  }, [_c('b', [_vm._v("GOING, GOING, GONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch18a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter018#ch18a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter018#ch18"
    }
  }, [_vm._v("The Death of Gerald Bull")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch34"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter034#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Went Thataway")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch75"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter075#ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weird Bequests")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch98"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter098#ch98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Do Your Best!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch216"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter216#ch216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it to the Grave")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch240"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter240#ch240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Died With Their Chutes On")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch174a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter174#ch174a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch174"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter174#ch174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Went Thataway")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch121aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter121#ch121aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("MYTHS & LEGENDS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch121a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter121#ch121a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch121"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter121#ch121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Myth Conceptions")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch197"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter197#ch197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jack Tales")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch183a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter183#ch183a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch183"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter183#ch183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Lady of the Little Green Men")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch238a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter238#ch238a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch238"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter238#ch238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Jack and the Heifer Hide”")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch243"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter243#ch243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hiyo, Silver—Away!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch47aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter047#ch47aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PLAY TIME")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch47a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter047#ch47a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch47"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter047#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NBA Draft Busts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch50"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter050#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Croakers & Soakers")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch104"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter104#ch104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Medal Shocker")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch116"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter116#ch116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steamers & Wongers")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch143"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter143#ch143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NFL Draft Flops")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch153"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter153#ch153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Medal Shocker, Part II")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch191"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter191#ch191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Drive, No Five!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch209"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter209#ch209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Medal Shocker Part III")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch236"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter236#ch236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkeys & Whales")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch80a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter080#ch80a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch80"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter080#ch80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extreme Sport: BASE Jumping")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch186"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter186#ch186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extreme Sport: Free-Solo Climbing")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch214"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter214#ch214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Go Cowboys!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch54aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter054#ch54aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("APOCALYPSE, NAH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch54a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter054#ch54a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch54"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter054#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Ways To Light a Fire Without Matches")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch198"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter198#ch198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How To Make a “Solar Still”")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch21a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter021#ch21a"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch21"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter021#ch21"
    }
  }, [_vm._v("Armageddon Outta Here!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch145"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter145#ch145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome to Year Zero")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch206"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter206#ch206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New and Improved Calendars")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch230"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter230#ch230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s the End of the World as They Know It")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch46aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter046#ch46aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("POP SCIENCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch46a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter046#ch46a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch46"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter046#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moon Trees")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch105"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter105#ch105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Neanderthals")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch108"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter108#ch108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antipodes 101")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch45a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter045#ch45a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch45"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter045#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feral Children of the Modern World")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch89"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter089#ch89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Did the Moon Come From?")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch260"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter260#ch260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gangrene Explained")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch265a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter265#ch265a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch265"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter265#ch265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Origin of DNA Testing")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch20aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter020#ch20aa"
    }
  }, [_c('b', [_vm._v("INTERNATIONAL AFFAIRS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch20a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter020#ch20a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch20"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter020#ch20"
    }
  }, [_c('i', [_vm._v("Michin Saekki")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch51"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter051#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canadian Firsts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch87"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter087#ch87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Z-People")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch194"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter194#ch194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biscuit = Cookie")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch232"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter232#ch232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The United States Of "), _c('i', [_vm._v("Belgium")]), _vm._v("?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch13a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter013#ch13a"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter013#ch13"
    }
  }, [_vm._v("Uncle John’s Weird Travel Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch72"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter072#ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man Meets Cartoon")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch137"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter137#ch137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canada’s Métis People")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch175a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter175#ch175a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch175"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter175#ch175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s All "), _c('i', [_vm._v("Bla")]), _vm._v("t To Me")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch93aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter093#ch93aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("HOW TO DO STUFF")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch93a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter093#ch93a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch93"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter093#ch93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Household Hints")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch124"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter124#ch124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not-So-Stupid Dishwasher Tricks")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch180"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter180#ch180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Must Remember This")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch224"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter224#ch224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRI’s Packing Tips")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch261"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter261#ch261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Before Spell-Check")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch57aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter057#ch57aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TOYS & GAMES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch57a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter057#ch57a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch57"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter057#ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What a Card!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch110"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter110#ch110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Land of the Rising Fun")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch182a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter182#ch182a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch182"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter182#ch182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Send In for It")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch28aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter028#ch28aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("NO CAN DO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch28a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter028#ch28a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch28"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter028#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Man Bans")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch81"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter081#ch81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Much Ado About Jugs and Screws")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch135"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter135#ch135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banned!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch164"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter164#ch164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Man Bans")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch256a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter256#ch256a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Medium")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch256"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter256#ch256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banned Books")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch1aa"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1aa"
    }
  }, [_c('b', [_vm._v("POP-POURRI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch1a"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1a"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1"
    }
  }, [_vm._v("You’re My Inspiration")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch24"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter024#ch24"
    }
  }, [_vm._v("Q&A: Ask the Experts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch41"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter041#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Year’s Eve Opossum Drop")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch58"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter058#ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncle John’s Page of Lists")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch64"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter064#ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fan Club Funnies")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch102"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter102#ch102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("World’s Highest…")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch112"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter112#ch112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vomit Comets")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch141"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter141#ch141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q&A: Ask the Experts")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch162"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter162#ch162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sine of the Times")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch244"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter244#ch244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Q&A: Ask the Experts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch266a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter266#ch266a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch266"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter266#ch266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*Thanks for Nothing")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1l",
    attrs: {
      "id": "rch138aa"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter138#ch138aa",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("THE BODY ECLECTIC")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch138a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter138#ch138a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Short")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch138"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter138#ch138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Odd Body Tips & Tricks")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch218"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter218#ch218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The #2 Report")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "rch254a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter254#ch254a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Long")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang7",
    attrs: {
      "id": "rch254"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter254#ch254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Human Guinea Pigs")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('b', [_vm._v("*"), _c('span', {
    staticClass: "spaces"
  }), _vm._v("*"), _c('span', {
    staticClass: "spaces"
  }), _vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1c"
  }, [_c('span', [_c('b', [_vm._v("IT’S OXYMORONIC!")])])]), _vm._v(" "), _c('p', {
    staticClass: "center5"
  }, [_c('span', [_c('i', [_vm._v("Phrases made up of two words that appear to be contradictory.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("New classic")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Seriously funny")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Crash landing")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Deafening silence")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Larger half")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Soft rock")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Living dead")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Almost exactly")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Working vacation")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Center around")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Original copies")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Clearly misunderstood")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Peacekeeper missile")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Decreased growth")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Found missing")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Rolling stop")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Same difference")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Definite maybe")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Specialize in everything")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Sweet tart")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Virtual reality")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Butt head")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0